import { render } from "./AllShipsCallMenu.vue?vue&type=template&id=28b0cb0a&scoped=true"
import script from "./AllShipsCallMenu.vue?vue&type=script&lang=js"
export * from "./AllShipsCallMenu.vue?vue&type=script&lang=js"

import "./AllShipsCallMenu.vue?vue&type=style&index=0&id=28b0cb0a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b0cb0a"]])

export default __exports__